{
  "version": 1,
  "asset_id": "b9fb539f-8815-4a64-9578-e02719a95799",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/b9fb539f-8815-4a64-9578-e02719a95799/contact-banner.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/b9fb539f-8815-4a64-9578-e02719a95799/contact-banner.png",
  "original_filename": "contact-banner.png",
  "size": 937430,
  "content_type": "image/png",
  "created_at": "2026-06-24T09:02:09Z"
}
